import { defineTextStyles } from "@chakra-ui/react";

export const SYSTEM_COMMON = {
  theme: {
    semanticTokens: {
      colors: {
        primary: {
          contrast: {
            value: {
              base: "{colors.white}",
              _dark: "{colors.white}",
            },
          },
          fg: {
            value: {
              base: "{colors.primary.700}",
              _dark: "{colors.primary.300}",
            },
          },
          subtle: {
            value: {
              base: "{colors.primary.100}",
              _dark: "{colors.primary.900}",
            },
          },
          muted: {
            value: {
              base: "{colors.primary.200}",
              _dark: "{colors.primary.800}",
            },
          },
          emphasized: {
            value: {
              base: "{colors.primary.300}",
              _dark: "{colors.primary.700}",
            },
          },
          solid: {
            value: {
              base: "{colors.primary.700}",
              _dark: "{colors.primary.700}",
            },
          },
          focusRing: {
            value: {
              base: "{colors.primary.600}",
              _dark: "{colors.primary.600}",
            },
          },
        },
        secondary: {
          contrast: {
            value: {
              base: "{colors.white}",
              _dark: "{colors.white}",
            },
          },
          fg: {
            value: {
              base: "{colors.secondary.700}",
              _dark: "{colors.secondary.300}",
            },
          },
          subtle: {
            value: {
              base: "{colors.secondary.100}",
              _dark: "{colors.secondary.900}",
            },
          },
          muted: {
            value: {
              base: "{colors.secondary.200}",
              _dark: "{colors.secondary.800}",
            },
          },
          emphasized: {
            value: {
              base: "{colors.secondary.300}",
              _dark: "{colors.secondary.700}",
            },
          },
          solid: {
            value: {
              base: "{colors.secondary.600}",
              _dark: "{colors.secondary.600}",
            },
          },
          focusRing: {
            value: {
              base: "{colors.secondary.600}",
              _dark: "{colors.secondary.600}",
            },
          },
        },
      },
    },
    components: {
      Dialog: {
        sizes: {
          "2xl": {
            content: {
              maxW: "1200px",
            },
          },
        },
      },
    },
    textStyles: defineTextStyles({
      h1: {
        value: {
          fontSize: { base: "1.25rem", lg: "2rem" },
          fontWeight: 400,
          letterSpacing: "2%",
        },
      },
      h2: {
        value: {
          fontSize: { base: "1.75rem", lg: "1.875rem" },
          fontWeight: 300,
        },
      },
      h3: {
        value: {
          fontSize: "1.625rem",
          fontWeight: 300,
        },
      },
      h4: {
        value: {
          fontSize: "1.375rem",
          fontWeight: 300,
        },
      },
      h5: {
        value: {
          fontSize: "1.125rem",
          fontWeight: 400,
        },
      },
      "text-lg": {
        value: {
          fontSize: "18px",
          fontWeight: 400,
        },
      },
      "text-md": {
        value: {
          fontSize: "1rem",
          fontWeight: 300,
          lineHeight: "1.255rem",
        },
      },
      "text-sm": {
        value: {
          fontSize: "0.875rem",
          fontWeight: 300,
        },
      },
      "text-xs": {
        value: {
          fontSize: "0.75rem",
          fontWeight: 400,
        },
      },
      "button-md": {
        value: {
          fontSize: "1rem",
          fontWeight: 400,
        },
      },
      "input-label": {
        value: {
          fontSize: "1rem",
          fontWeight: 400,
          lineHeight: "normal",
        },
      },
    }),
    keyframes: {
      pulse2: {
        "0%, 20%": {
          transform: "scale(1)",
        },
        "10%": {
          transform: "scale(1.05)",
        },
      },
    },
  },
  globalCss: {
    html: {
      scrollPaddingTop: "87px",
    },
    body: {
      fontFamily: '"Mulish", sans-serif',
    },
    ".material-symbols-outlined": {
      fontFamily: "Material Symbols Outlined",
    },
  },
};
